import React from "react";
import { Box, Chip, Tooltip, Typography } from "@mui/material";

// A preset whose channels are still an approximation carries its gap list from
// core (GET /convo/presets). Shown as a maturity note — "alpha" reads the same
// way to engineers and narrative designers — with the list on hover, so the
// caveat is always visible but never buries the answers.
const ParityGapsChip = (props) => {
  const { gaps = [] } = props;
  if (gaps.length === 0) return null;

  // Core tags each gap with its matcher stage; summarising by stage keeps the
  // tooltip to a handful of lines instead of every open task.
  const byArea = gaps.reduce((acc, gap) => ({ ...acc, [gap.area]: (acc[gap.area] || 0) + 1 }), {});

  return (
    <Tooltip
      title={
        <Box sx={{ maxHeight: 320, overflowY: "auto" }}>
          <Typography variant="caption" sx={{ fontWeight: 700 }}>
            {`Alpha: faithful CWS parity is in progress — ${gaps.length} behaviours still missing`}
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2 }}>
            {Object.entries(byArea).map(([area, count]) => (
              <Typography key={area} component="li" variant="caption" sx={{ display: "list-item" }}>
                {`${area} — ${count}`}
              </Typography>
            ))}
          </Box>
        </Box>
      }
    >
      <Chip size="small" color="warning" variant="outlined" label="alpha" />
    </Tooltip>
  );
};

export default ParityGapsChip;
